<div class="dashboard-calculated-variables">
  <dashboard-loader
    *ngIf="loadingCalculatedVariables$ | async"
    [title]="'Loading Calculated Variables...'"
  ></dashboard-loader>
  <div *ngIf="isCalculatedVariablesLoaded$ | async">
    <div fxLayout="row" fxLayoutAlign="space-between center" class="dashboard-calculated-variables-title">
      {{ dataSource?.data.length ? 'Calculated Variables' : 'No calculated variables yet' }}
      <button
        fxLayout="row"
        fxLayoutAlign="end"
        mat-raised-button
        color="accent"
        (click)="openCreateCalculatedVariableDialog()"
      >
        {{ 'Add Calculated Variable' | uppercase }}
      </button>
    </div>
    <div *ngIf="dataSource?.data.length">
      <table
        mat-table
        [dataSource]="dataSource"
        [hidden]="!dataSource?.data.length"
        fxFill
        class="dashboard-calculated-variables__table"
      >
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td
            mat-cell
            *matCellDef="let calculatedVariable"
            (click)="openUpdateCalculatedVariableDialog(calculatedVariable)"
          >
            {{ calculatedVariable?.uniqueName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef>Description</th>
          <td
            mat-cell
            *matCellDef="let calculatedVariable"
            (click)="openUpdateCalculatedVariableDialog(calculatedVariable)"
          >
            {{ calculatedVariable?.description }}
          </td>
        </ng-container>

        <ng-container matColumnDef="formula">
          <th mat-header-cell *matHeaderCellDef>Formula</th>
          <td
            mat-cell
            *matCellDef="let calculatedVariable"
            (click)="openUpdateCalculatedVariableDialog(calculatedVariable)"
          >
            {{ calculatedVariable?.formula }}
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let calculatedVariable">
            <mat-icon
              class="dashboard-calculated-variables__table-delete"
              color="primary"
              #tooltip="matTooltip"
              matTooltip="Delete this calculated variable"
              matTooltipPosition="above"
              (click)="openDeleteCalculatedVariableDialog(calculatedVariable)"
              >delete
            </mat-icon>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: columnsToDisplay"
          class="dashboard-calculated-variables__table-row"
        ></tr>
      </table>
    </div>
  </div>
</div>
